import {
    GridCellParams,
    GridColDef,
    GridRenderCellParams,
    useGridApiRef,
} from "@mui/x-data-grid";
import { Button } from "@mui/material";
import { useTranslation } from "../../explorer/hooks/useTranslation";
import useBrands from "../../explorer/hooks/useBrands";
import { useEffect, useRef, useState } from "react";
import useLanguages from "../../explorer/hooks/useLanguages";
import {
    BasketUploadInfo,
    BasketUploadItem,
    StatusType,
} from "../../explorer/types/Basket/BasketUploadPartInfo";
import ServiceProvider from "../configuration/ServiceProvider";
import { BasketItemDTO } from "../../explorer/types/Basket/BasketItems";
import { useBasket } from "./useBasket";
import { Basket } from "../../explorer/types";
import { useApiError } from "./useApiError";
import { useApiNotification } from "./useApiNotification";
import useGoToPage from "./useGoToPage";
import { useLocation, useNavigate } from "react-router";
import useRefresh from "./useRefresh";
import { exit } from "process";

export const useBasketUpload: () => {
    handleRowSelection: (params: GridRenderCellParams | GridCellParams) => void;
    handlePaste: (
        event: React.ClipboardEvent<HTMLDivElement>
    ) => Promise<boolean>;
    handleCopy: () => string;

    handleMouseDown: (event: any) => void;
    handleMouseUp: (event: any) => void;
    handleMouseEnter: (event: any) => void;
    handleCellClick: (params: GridCellParams) => void;
    processRowUpdate: (newRow: any, oldRow: any) => any;
    isCellSelected: (id: string | number, field: string) => any;
    getCssClassSelected: (id: string | number, field: string) => any;
    setColums: (columns: GridColDef[]) => void;
    createImportItem: (code: string, quantity: number | "",mcc:string|"") => any;
    createEmptyItem: (id: number) => any;
    updateDataUploaded: (data: any) => any;
    handleCellDelete: () => any;
    data: BasketUploadItem[];
    selectedRow: number | null;
    MAX_ROWS: number;
    handleSaveOrMergeFinal: (
        isCreate: boolean,
        basketId: number | null
    ) => Promise<string>;

    hasValidParts: () => any;
    hasErrorParts: () => any;
    addNewEmptyRows: (id: number) => void;
    handleSelectAllCells: () => void;
} = () => {
    const { t } = useTranslation();
    const brand = useBrands().currentBrandUrl;
    const { currentLanguage } = useLanguages();
    const apiRef = useGridApiRef();
    const goToPage = useGoToPage();
    const currentBasket = useBasket().currentBasket;
    const [selectedBasket, setSelectedBasket] = useState<Basket>(currentBasket);

  
    const currentBrand = useBrands().currentBrand;
    const navigate = useNavigate();

    const location = useLocation();
    const MAX_ROWS = 100
    const INITIAL_ROWS = 14

    const isValidPart = (code:StatusType|'') =>{
        const _res:boolean = code == StatusType.Replaced || code == StatusType.Ok 
        return _res;
    }

    const isNotValidPart = (code:StatusType|'') =>{
        const _res:boolean = code == StatusType.Error || code == StatusType.NotActive 
        return _res;
    }
    
    function isInteger(str: string): boolean {
        // Check if the string matches the regular expression for an integer
        const integerRegex = /^-?\d+$/;
        if (!integerRegex.test(str)) {
            return false;
        }

        // Parse the string to an integer and check if it is a valid number
        const num = parseInt(str, 10);
        return !isNaN(num);
    } 
    const  isNumber = (value: any) => {
        return (
            value !== null &&
            value !== undefined &&
            !isNaN(parseFloat(value)) &&
            isFinite(Number(value))
        );
    }
    const createEmptyItem = (id: number) => {
        var result: BasketUploadItem = {
            id: id,
            itemCode: "",
            quantity: "",
            manufacturerCompanyCode:"",
            //status: { code: "", message: "" },
            status: { code: "", message: "" },
            replacementCode: "",
            description: "",
            images: undefined,
            errorDetail: "",
        };
        return result;
    };
    const fieldToCheck = [
        "selectRow",
        "itemCode",
        "quantity",
        "manufacturerCompanyCode",
    ];
    const hasValidParts = () => {
        return (
            data.filter(
                (row) => isValidPart(row.status.code)
            ).length > 0
        );
    };

    const hasErrorParts = () => {
        return data.filter((row) => isNotValidPart(row.status.code)).length;
    };

    const handleSaveOrMergeFinal = async (
        isCreate: boolean,
        basketId: number | null
    ) => {
        var items: BasketItemDTO[] = [];

        data.filter(
            (row) =>
                isValidPart(row.status.code)
        ).map((row: BasketUploadItem) => {
            items.push({
                code:
                    row.replacementCode === null ||
                    row.replacementCode === undefined ||
                    row.replacementCode === ""
                        ? row.itemCode.trim()
                        : row.replacementCode.trim(),
                qty: isNumber(row.quantity) ? +row.quantity : 1,
                basketId: isCreate ? basketId! : selectedBasket.id,
                navContext: "",
                manufacturerCompanyCode: row.manufacturerCompanyCode,
                replacedCode:
                    row.replacementCode === null ||
                    row.replacementCode === undefined ||
                    row.replacementCode === ""
                        ? ""
                        : row.itemCode.trim(),
            });
        });
        
        //
        let result="true";
         await ServiceProvider.Basket.AddBasketItems(items)
             .catch((errors) => {
                 if (errors)
                     result = errors.map(
                         (e: { errorCode: string | undefined , errorMessage:string | undefined}) =>
                             t(`basket.items.${e.errorCode}`)+" "  + e.errorMessage 
                     );
                 else result = t("basket.genericError");
             })
             .then((result) => {
                 //result=(t("common.basket.itemsAdded"));
             });


        return result;
    };

    const createImportItem = (code: string, quantity: number | "",mcc:string|"") => {
        var result: BasketUploadItem = {
            itemCode: code,
            quantity: quantity,
            manufacturerCompanyCode: mcc,
            status: { code: "", message: "" },
            replacementCode: "",
            description: "",
            images: undefined,
            errorDetail: "",
            
        };
        return result;
    };

    const initialData: BasketUploadItem[] = Array.from(
        { length: INITIAL_ROWS },
        (_, index) => ({
            id: index,
            itemCode: "",
            quantity: "",
            status: { code: "", message: "" },
            replacementCode: "",
            description: "",
            images: undefined,
            errorDetail: "",
            manufacturerCompanyCode: "",
        })
    );

    const [data, setData] = useState<BasketUploadItem[]>(initialData);
    const [columns, setColums] = useState<GridColDef[]>();

    const [selectedCells, setSelectedCells] = useState<{
        [key: string]: boolean;
    }>({});

    var dragEndState = { id: "", field: "" };
    var dragStartState = { id: "", field: "" };
    const handleCellClick = (params: GridCellParams) => {
        const cellKey = `${params.id}-${params.field}`;
        
        setSelectedCells((prevSelectedCells) => ({
            ...prevSelectedCells,
            [cellKey]: !prevSelectedCells[cellKey],
        }));
    };

    const dragStartRef = useRef<{ id: string | number; field: string } | null>(
        null
    );
    const dragEndRef = useRef<{ id: string | number; field: string } | null>(
        null
    );

    const handleMouseEnter = (event: any /*,params: GridCellParams*/) => {
        event.preventDefault();
        if (dragStartRef.current != null) {
            const current = {
                id: event.currentTarget.parentNode.attributes["data-id"].value,
                field: event.currentTarget.attributes["data-field"].value,
            };
            dragEndRef.current = current;

            dragEndState = current;
            dragStartState = current;
            selectCellsInRange(dragStartRef.current, dragEndRef.current);
        }
    };

    const handleMouseDown = (event: any /*,params: GridCellParams*/) => {
        event.preventDefault();

        const current = {
            id: event.currentTarget.parentNode.attributes["data-id"].value,
            field: event.currentTarget.attributes["data-field"].value,
        };
        if (dragStartRef.current == null) {
            dragStartRef.current = current;
            dragEndRef.current = current;
            dragEndState = current;
            dragStartState = current;
        } else {
            dragEndRef.current = current;
            dragEndState = current;
        }
        selectCellsInRange(dragStartRef.current, dragEndRef.current);

        
    };

    const handleMouseUp = (event: any /*,params: GridCellParams*/) => {
        event.preventDefault();
        if (dragStartRef.current) {
            const start = dragStartRef.current;

            const end = {
                id: event.currentTarget.parentNode.attributes["data-id"].value,
                field: event.currentTarget.attributes["data-field"].value,
            };
            setSelectedCells({});
            setSelectedRow(null);
            //if (activeSelectingRow) {
                setActiveSelectingRow(false);
            //} else {
                selectCellsInRange(start, end);
            //}

            dragStartRef.current = null;
            dragEndRef.current = null;

            dragEndState = { id: "", field: "" };
            dragStartState = { id: "", field: "" };
        }
    };

    const processRowUpdate = async (newRow: any, oldRow: any) => {
        let updatedRows = [...data];
        if (newRow.itemCode != oldRow.itemCode || newRow.manufacturerCompanyCode != oldRow.manufacturerCompanyCode) {
            if (newRow.itemCode == "") {
                let _item = createEmptyItem(newRow.id);

                newRow = _item;
                updatedRows[newRow.id] = {
                    ..._item,
                };
            } else {
                if (newRow.manufacturerCompanyCode === '') {
                    newRow = {
                        ...newRow,
                        manufacturerCompanyCode: currentBrand!.manufacturers[0].code
                    };
                    
                }
                    var partsToUpdate: string[] = [];
                    partsToUpdate.push(newRow.manufacturerCompanyCode + "|" + newRow.itemCode.trim());
                    const dataInfo = getDataInfo(partsToUpdate);

                    (await dataInfo).forEach(
                        (rowData: BasketUploadItem, rowIndex) => {
                            if (newRow.quantity==='') newRow.quantity='1'
                            if (
                                !isInteger(newRow.quantity) ||
                                +newRow.quantity===0
                            ) {
                                newRow.status = {
                                    code: StatusType.Error,
                                    message: t("basket.upload.qty_invalid"),
                                };
                            } else {
                                newRow.status = rowData.status;
                            };
                            updatedRows[newRow.id] = {
                                ...rowData,
                                id: newRow.id,
                                quantity: newRow.quantity,
                                manufacturerCompanyCode:newRow.manufacturerCompanyCode,
                                status:newRow.status,
                            };
                            console.log(updatedRows[newRow.id]);
                        }
                    );
            }
            setData(await updatedRows);
        } else if (newRow.quantity != oldRow.quantity) {
            let _item = updatedRows[newRow.id];
            if ( !isInteger(newRow.quantity) ||
                                +newRow.quantity===0)
                 {
                newRow.status = {
                    code: StatusType.Error,
                    message: t("basket.upload.qty_invalid"),
                };
            } else {
                if (newRow.itemCode != "" && newRow.manufacturerCompanyCode!=''){
                    newRow.status = {
                        code: StatusType.Ok,
                        message: "",
                    };
                }
            }
            updatedRows[newRow.id] = {
                ..._item,
                id: newRow.id,
                quantity: newRow.quantity,
                status: newRow.status,
            };
            setData(await updatedRows);
        }

        return newRow;
    };

    const addNewEmptyRows = (id: number) => {
        let _item = createEmptyItem(id);
        let updatedRows = [...data];
        updatedRows[id] = {
            ..._item,
        };
        setData(updatedRows);
    };
    const updateDataUploaded = async (uploadData: any) => {
        const partsToUpdate = uploadData
            .filter((row: string) => row !== undefined && row != "");
        if (partsToUpdate.length > MAX_ROWS) return false;
        setData(initialData);
    
      return await loadPastedOrUploadeData(partsToUpdate, 0);
    }
    

    const getDataInfo = async (partsToUpdate: any) => {
        const ret: BasketUploadItem[] = [];
        /*const partsToUpdate = clipboardData
            .map((row: any[]) => row[0])
            .filter((row: string) => row !== undefined && row != "");
        */
        const result: BasketUploadInfo =
            await ServiceProvider.Basket.checkItemsForBasketUpload(
                brand,
                currentLanguage,
                partsToUpdate
            );
        if (result.parts.length > 0) {
            partsToUpdate.forEach((partToUpdate: string, _i: any) => {
                const [_mcc, _code] = partToUpdate.split("|");
                let indexFound = result.parts.findIndex(
                    (item) => _code === item.itemCode
                );

                if (indexFound > -1) {
                    let itemData: BasketUploadItem = result.parts[indexFound];
                    if (itemData.status.code=== StatusType.NotActive) {
                        itemData.status.message=t("basket.uploadbasket.part_not_active")
                    }
                    ret.push(result.parts[indexFound]);

                } else {
                    let _item = createImportItem(_code, "",_mcc);
                   
                    if (_code!=='') {
                        let _message=t("common.spareparts.searchpage.results.title.no_results");
                        /* eslint-disable @typescript-eslint/no-unused-expressions */
                        if ( _mcc=='' || currentBrand!.manufacturers.filter( (manufacturer) => _mcc==manufacturer.code).length == 0) {
                            _message=t("basket.uploadbasket.mcc_empty");
                        };
                        _item.status = {
                                code: StatusType.Error,
                                message: _message
                        };
                    }
                    ret.push(_item);
                    
                }
            });
        } else {
            partsToUpdate.forEach((partToUpdate: string, _i: any) => {
                  const [_mcc,_code] = partToUpdate.split("|");
                let _item = createImportItem(_code, "",_mcc);
                /* eslint-disable @typescript-eslint/no-unused-expressions */
                let _message=t("common.spareparts.searchpage.results.title.no_results")
                if ( _mcc=='' || currentBrand!.manufacturers.filter( (manufacturer) => _mcc==manufacturer.code).length == 0) {
                    _message=t("basket.uploadbasket.mcc_empty");
                };
                (_item.status = {
                    code: StatusType.Error,
                    message:  _message,
                }),
                    /* eslint-enable @typescript-eslint/no-unused-expressions */
                    ret.push(_item);
            });
        }
        return ret;
    };

    const getFirstRowCell = () => {
        const sortedKeys = Object.keys(selectedCells).sort((a, b) => {
            const numA = parseInt(a.split("-")[0]);
            const numB = parseInt(b.split("-")[0]);
            return numA - numB;
        });
        return sortedKeys == null ? "0-itemCode" : sortedKeys[0];
    };

    const getLastRowCell = () => {
        const sortedKeys = Object.keys(selectedCells).sort((a, b) => {
            const numA = parseInt(a.split("-")[0]);
            const numB = parseInt(b.split("-")[0]);
            return numB - numA;
        });
        return sortedKeys == null ? "0-itemCode" : sortedKeys[0];
    };

    const handlePaste = async (event: React.ClipboardEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();

        const firstRowSelected = getFirstRowCell();

        const [idSelected] = firstRowSelected.split("-");

        const clipboardData = event.clipboardData.getData("text");

        const parsedData: string[][] = clipboardData
            .split("\n")
            .map((row) => row.split("\t"));
        parsedData.map((row) => {   
            row[row.length - 1] = row[row.length - 1].replace(/[\r\n]/g, "");
            if (row[0]!='' && row.length==2 ) {
                row[2]= ''+currentBrand!.manufacturers[0].code
            }
          
        });

        const startRowIndex = data.findIndex(
            (row) => "" + row.id === idSelected
        );
        return (await loadPastedOrUploadeData(parsedData,startRowIndex));
    };

    const loadPastedOrUploadeData = async (parsedData: string[][], startRowIndex:number) => {
        const _listPartsQty: { [key: string]: string } = {};
        const listPartsQty: { [key: string]: number } = {};
       
        parsedData.forEach(item => {
            if (item.length>0 && item[0]==='') {
                return; 
            }            
            let code=item[0];
            let quantity= (item[1] !== undefined && item[1] != "") ? item[1].trim() : "1";
            let mcc:string= (item[2] !== undefined && item[2] != "")  ? item[2].trim().toUpperCase() : "";
            
            const key = `${mcc}|${code}`;
            const value = parseInt(quantity, 10);
        
            if (listPartsQty[key]) {
                listPartsQty[key] += value;
            } else {
                listPartsQty[key] = value;
            }
        
        });
        
         const partsToUpdate = Object.keys(listPartsQty);
        
        const updatedRows = [...data];
        let maxItemsReached=false;
        try{
            (await getDataInfo(partsToUpdate)).forEach((rowData: BasketUploadItem, rowIndex) => {
                const rowIndexToUpdate = startRowIndex + rowIndex;
                if (rowIndexToUpdate  >= MAX_ROWS) {
                    throw new Error("MaxItemReached");
                }
                let _key= `${rowData.manufacturerCompanyCode}|${rowData.itemCode}`; 
                rowData.quantity = listPartsQty[_key];
                if (
                    !isInteger(""+listPartsQty[_key]) ||
                    listPartsQty[_key]===0
                ) {
                    rowData.status = {
                        code: StatusType.Error,
                        message: t("basket.upload.qty_invalid"),
                    };
                } else {
                }

                if (updatedRows[rowIndexToUpdate] !== undefined) {
                    updatedRows[rowIndexToUpdate] = {
                        ...rowData,
                        id: rowIndexToUpdate,
                    };
                } else {
                    updatedRows[rowIndexToUpdate] = {
                        ...rowData,
                        id: rowIndexToUpdate,
                    };
                }
            });
        } catch (e:any) {
            if (e.message !== 'MaxItemReached') {
                maxItemsReached=true;
            }
        }

        setData(updatedRows);

        return true;
    };


    const handleCopy = () => {
        let copyText: string = "";
        Object.keys(selectedCells).forEach((_k) => {
            const [idSelected, fieldSelected] = _k.split("-");
            copyText += data[+idSelected].itemCode + "\n";
        });
        return copyText;
    };

    const handleCellDelete = () => {
        Object.keys(selectedCells).forEach((_k) => {
            const [idSelected, fieldSelected] = _k.split("-");
            let _item = createEmptyItem(+idSelected);
            setData((prevData) => {
                const index = prevData.findIndex((row) => row.id === _item.id);
                if (index !== -1) {
                    const updatedData = [...prevData];
                    updatedData[index] = _item;
                    return updatedData;
                }
                return prevData;
            });
        });

        // setSelectedCells({});
        setSelectedRow(null);
    };
    const selectCellsInRange = (
        start: { id: string | number; field: string },
        end: { id: string | number; field: string }
    ) => {
        const newSelectedCells: { [key: string]: boolean } = {};

        if (!fieldToCheck.some((substring) => end.field.includes(substring)))
            return;
        if (!fieldToCheck.some((substring) => start.field.includes(substring)))
            return;

        let startRowIndex, endRowIndex, startColIndex, endColIndex;
        startRowIndex = data.findIndex((row) => "" + row.id === "" + start.id);
        endRowIndex = data.findIndex((row) => "" + row.id === "" + end.id);

        if (start.field == "selectRow") {
            startColIndex = 0;
            endColIndex = columns!.length - 1;
        } else {
            startColIndex = columns!.findIndex(
                (col) => col.field === start.field
            );
            endColIndex = columns!.findIndex((col) => col.field === end.field);
        }

        for (
            let rowIndex = Math.min(startRowIndex, endRowIndex);
            rowIndex <= Math.max(startRowIndex, endRowIndex);
            rowIndex++
        ) {
            for (
                let colIndex = Math.min(startColIndex, endColIndex);
                colIndex <= Math.max(startColIndex, endColIndex);
                colIndex++
            ) {
                const cellKey = `${data[rowIndex].id}-${
                    columns![colIndex].field
                }`;
                newSelectedCells[cellKey] = true;
            }
        }

        setSelectedCells(newSelectedCells);
    };

    const isCellSelected = (id: string | number, field: string) => {
        return !!selectedCells[`${id}-${field}`];
    };

    const getCssClassSelected = (id: string | number, field: string) => {
        if (!fieldToCheck.includes(field)) return;

        const [firstRowCellId, firstRowCellField] =
            getFirstRowCell().split("-");
        const [lastRowCellId, lastRowCellField] = getLastRowCell().split("-");
        let _res = "";
        if (firstRowCellId == id) _res += " top ";
        if (field == "itemCode") {
            _res += isCellSelected(id, "selectRow") ? "" : " left ";
            _res += isCellSelected(id, "quantity")
                ? ""
                : " right ";
         } else if (field == "quantity") {
            _res +=  (isCellSelected(id, "itemCode")) ? "  ": " left ";
            _res += isCellSelected(id, "manufacturerCompanyCode") ? " " :" right ";
                
        } else if (field == "manufacturerCompanyCode") {
            _res += " right ";
            _res += isCellSelected(id, "quantity") ? " " : " left ";
        } else if (field == "selectRow") {
            _res += " left ";
            _res += isCellSelected(id, "itemCode") ? "" : " right ";
        }

        if (lastRowCellId == id) _res += " bottom ";

        return _res;
    };

    const _getCssClassSelected = (id: string | number, field: string) => {
        console.log("id=" + id + " field=" + field);
        let _res = "  prova ";
        if (dragStartState.id != "" && dragStartState.id === id)
            _res += " top ";
        if (dragEndState.field != "" && dragEndState.field === field)
            _res += " right ";
        if (dragStartState.field != "" && dragStartState.field === field)
            _res += " left ";
        if (dragEndState.id != "" && dragEndState.id === id) _res += " bottom ";

        return _res;
    };

    const [selectedRow, setSelectedRow] = useState<number | null>(null);
    const [activeSelectingRow, setActiveSelectingRow] =
        useState<boolean>(false);

    const handleSelectAllCells = () => {
        const start = {
            id: "" + 0,
            field: columns![0].field,
        };
        const end = {
            id: "" + (data.length-1),
            field: columns![2].field,
        };
        selectCellsInRange(start, end);
        
        dragStartRef.current = null;
        dragEndRef.current = null;

        dragEndState = { id: "", field: "" };
        dragStartState = { id: "", field: "" };
        setActiveSelectingRow(false);
    };

    const handleRowSelection = (
        params: GridRenderCellParams | GridCellParams
    ) => {
        
        let id = params.row.id;
        setSelectedRow(id);
        setSelectedCells({});
        const start = {
            id: id,
            field: columns![0].field,
        };
        const end = {
            id: id,
            field: columns![2].field,
        };
        selectCellsInRange(start, end);
        dragStartRef.current = null;
        dragEndRef.current = null;

        dragEndState = { id: "", field: "" };
        dragStartState = { id: "", field: "" };
        setActiveSelectingRow(false);
    };
    return {
        MAX_ROWS,
        data,
        selectedRow,
        setColums,
        handleRowSelection,
        handlePaste,
        handleCopy,
        handleMouseDown,
        handleMouseUp,
        handleMouseEnter,
        handleCellClick,
        processRowUpdate,
        isCellSelected,
        getCssClassSelected,
        createImportItem,
        createEmptyItem,
        updateDataUploaded,
        handleCellDelete,

        handleSaveOrMergeFinal,
        hasValidParts,
        hasErrorParts,
        addNewEmptyRows,
        handleSelectAllCells,
    };
};
